

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 支払い管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CDataTable
                :hover="true"
                :striped="true"
                :items="payments"
                :fields="fields"
                :loading="isLoading"
                pagination
                :tableFilter="true"
                @update:table-filter-value="search"
              >
                <template #name="{item}">
                  <td>
                    <CLink :href="'/users/' + item.id" > {{ item.first_name }} {{item.sur_name}} {{ item.last_name }}</CLink>
                  </td>
                </template>
                <template #gender="{item}">
                  <td> {{ formatGender(item.gender) }}</td>
                </template>
                <template #industry_id="{item}">
                  <td> {{ industryTypes[item.industry_id] }}</td>
                </template>
                <template #created_at="{item}">
                  <td> {{formatDate(item.created_at)}}</td>
                </template>

              </CDataTable>
              <CPagination
                :activePage.sync="page"
                :pages="meta.total_pages"
                align="center"
                @update:activePage="updatePageData"
              />
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <user-modal  @hide="hideRecordModal()" :record="record" :recordModal="recordModal" :industryTypes="industryTypes"></user-modal>

  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import UserModal from "../../components/UserModal";
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {UserModal},
  data() {
    return {
      recordModal: false,
      deleteModal: false,
      page: 1,
      word: "",
      isLoading: true,
      record: {},
      payments: [],
      industryTypes: {},
      meta: {},
      fields: [
        { key: 'id', label: "ID"},
        { key: 'industry_id', label: "業種"},
        { key: 'name', label: "ユーザー名"},
        { key: 'gender', label: "性別"},
        { key: 'exam_day', label: "試験日"},
        { key: 'payment_id', label: "paypal支払いID"},
        { key: 'line_id', label: "LINE ID"},
        { key: 'language', label: "言語"},
        { key: 'created_at', label: "作成日"},
      ],
    }
  },
  methods: {
    formatData: function(d) {
        return moment(d).format("YYYY/MM/DD HH:mm")
    },
    formatBirthday: function(d) {
        return moment(d).format("YYYY/MM/DD")
    },
    formatGender: function(g) {
        return (g == "male")? "男性" : "女性"
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/users/" + this.record.id)
        .then(() => {
          this.deleteModal = false
          this.$router.push('/users')
        }).catch(error => {
          console.log(error)
        })
    },
    showRecordModal: function(i, index) {
      this.recordModal = true
      this.record = i

      this.itemIndex = index
    },
    search: function(e) {
      this.word = e
      if(e == "-") {
        this.word = ""
      }
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/payments?word=" + this.word + "&page=" + this.page, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.payments = response.data.payments
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
    },
    updatePageData: function(n, e) {
      this.page = n
      console.log(e)
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/payments?page=" + n + "&word=" + this.word, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
          this.payments = response.data.payments
          this.meta = response.data.meta
        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/payments", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          console.log(response)
          this.payments = response.data.payments
          this.meta = response.data.meta

          this.isLoading = false
      }).catch(error => {
          this.errorNotify(error.response)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          response.data.industries.forEach((i) => {
            this.industryTypes[i.id] = i.name
          })
      }).catch(error => {
          this.errorNotify(error.response)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
